// @ts-nocheck
/** *****
 * Store Custom Code:
 * For updates, compare with: modules\content-library\src\Widgets\Header\LogoLinksSearch.tsx
 * ****** */
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Hidden, { HiddenProps } from "@insite/mobius/Hidden";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

/* Store Custom Code - Start */
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { StyledButton } from "@insite/mobius/Clickable/Clickable";
import getColor from "@insite/mobius/utilities/getColor";
import { linkStyles } from "@store/Themes/common/mixins/link";
import { storeLogoStyles } from "@store/Themes/common/mixins/logo";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { siteWidthStyles } from "@toolkit/Themes/common/mixins";
import merge from "lodash/merge";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => {
    const isAuthenticated = getSession(state).isAuthenticated;

    return {
        hasViewOnlyRole: isAuthenticated && getSession(state).userRoles.includes("ViewOnly"),
        isAuthenticated,
    };
};

type Props = PageProps & ReturnType<typeof mapStateToProps>;
/* Store Custom Code - End */

export interface LogoLinksSearchStyles {
    container: InjectableCss;
    logoWrapper: InjectableCss;
    searchMenuWrapper: InjectableCss;
    linkListHidden: HiddenProps;
    // Store Custom Code
    linksMenuWrapper?: InjectableCss;
    linksMenuItems?: InjectableCss;
    linksMenuItemsEmpty?: InjectableCss;
}

export const logoLinksSearchStyles: LogoLinksSearchStyles = {
    /* Store Custom Code - Start */
    container: {
        css: css`
            ${x => siteWidthStyles(merge([], x.theme.design.layout.spacing.side, [0, 0, 0, pxToRem(45)]))}

            ${breakpoint("lg")} {
                display: flex;
                align-items: center;
                justify-content: space-between;
                padding-top: 20px;
                padding-bottom: 20px;
            }
        `,
    },
    logoWrapper: {
        css: css`
            ${storeLogoStyles()}
        `,
    },
    searchMenuWrapper: {
        css: css`
            width: 100%;

            ${breakpoint("md", "down")} {
                display: none;
            }

            ${breakpoint("lg", "down")} {
                flex-grow: 8;
            }
        `,
    },
    linkListHidden: {},
    linksMenuWrapper: {
        css: css`
            display: flex;

            ${breakpoint("md", "only")} {
                margin-left: 15px;
            }
        `,
    },
    linksMenuItems: {
        css: css`
            display: flex;
            align-items: center;
            border-right: 1px solid ${getColor("common.border")};
            white-space: nowrap;
            padding: 0 10px;

            ${StyledButton} {
                ${linkStyles("primary", null, false, false)}
                font-size: ${x => x.theme.design.typography.size.smaller};
                font-weight: ${x => x.theme.design.typography.weight.medium};
                text-transform: uppercase;
            }

            &:last-child {
                border-right: 0;
                padding-right: 0;
            }

            ${breakpoint("md")} {
                &:first-child {
                    border-left: 1px solid ${getColor("common.border")};
                }
            }

            ${breakpoint("lg")} {
                padding: 0 25px;

                &:first-child {
                    padding-left: 0;
                    border-left: 0;
                }
            }
        `,
    },
    linksMenuItemsEmpty: {
        css: css`
            border-right: 0;
        `,
    },
    /* Store Custom Code - End */
};

/* Store Custom Code - Start */
const LogoLinksSearch: React.FC<Props> = ({ id, hasViewOnlyRole, isAuthenticated }) => {
    const quickOrderStyles = css`
        ${logoLinksSearchStyles.linksMenuItems?.css}
        ${hasViewOnlyRole || !isAuthenticated ? logoLinksSearchStyles.linksMenuItemsEmpty?.css : null}
    `;

    return (
        <StyledWrapper {...logoLinksSearchStyles.container}>
            <Hidden below="lg" {...logoLinksSearchStyles.logoWrapper}>
                <Zone contentId={id} zoneName="Logo" />
            </Hidden>
            <StyledWrapper {...logoLinksSearchStyles.searchMenuWrapper}>
                <Zone contentId={id} zoneName="Search" />
            </StyledWrapper>
            <StyledWrapper {...logoLinksSearchStyles.linksMenuWrapper}>
                <Hidden below="md" css={quickOrderStyles}>
                    <Zone contentId={id} zoneName="QuickOrder" />
                </Hidden>
                <Hidden below="md" {...logoLinksSearchStyles.linksMenuItems}>
                    <Zone contentId={id} zoneName="SignIn" />
                </Hidden>
                <StyledWrapper {...logoLinksSearchStyles.linksMenuItems}>
                    <Zone contentId={id} zoneName="Cart" />
                </StyledWrapper>
            </StyledWrapper>
        </StyledWrapper>
    );
};
/* Store Custom Code - End */

const logoLinksSearch: WidgetModule = {
    component: connect(mapStateToProps)(LogoLinksSearch), // Store Custom Code
    definition: {
        group: "Common",
        icon: "magnifying-glass",
    },
};

export default logoLinksSearch;
